import $ from 'jquery';
import {getAjaxOpts} from './ajaxLogic';
import * as config from '../../config.json';
const debug = config.debug;

async function getAjax(url, auth) {
  let result;
  const opts = getAjaxOpts(url, 'GET', auth);
  await $.ajax(opts)
      .done(function(data) {
        debug && console.log(data);
        result = data;
      })
      .fail(function(xhr, status, error) {
      // Ajax request failed.
        const errorMessage = xhr.status + ': ' + xhr.statusText;
        debug && console.log('Error - ' + errorMessage);
      });
  return result;
}
export {getAjax};
